import { BaseTypography, type BaseTypographyProps } from './BaseTypography'

/**
 * Typography
 *
 *  Some consumers need to have dynamic titles, for this case this is fine to use
 *
 * Demos:
 * - [Typography](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/primitives-typography--docs)
 *
 */
export const Typography = BaseTypography

export type { BaseTypographyProps as TypographyProps }
